export const SCORE_TYPE_ID = {
  CREDIT_RISK: 1,
  PERFORMANCE: 2,
}
